// Single source of truth for the score / enrichment / confidence badges, so the
// People table, Person detail, and Dashboard always agree.

export type BadgeVariant = 'success' | 'warning' | 'error' | 'neutral' | 'info'

/** Relationship score (0-100) -> tier badge. */
export function scoreTier(score: number): { label: string; variant: BadgeVariant } {
  if (score >= 70) return { label: 'Hot', variant: 'success' }
  if (score >= 40) return { label: 'Warm', variant: 'warning' }
  return { label: 'Cold', variant: 'neutral' }
}

/** Enrichment confidence (0.0-1.0, or null = never enriched) -> tier badge. */
export function confidenceTier(value: number | null | undefined): { label: string; variant: BadgeVariant } {
  if (value == null) return { label: '—', variant: 'neutral' }
  const pct = Math.round(value * 100)
  if (value >= 0.75) return { label: `High · ${pct}%`, variant: 'success' }
  if (value >= 0.5) return { label: `Med · ${pct}%`, variant: 'warning' }
  return { label: `Low · ${pct}%`, variant: 'neutral' }
}

/** enrichment_status -> badge variant (backend values: none/pending/done/manual/not_found/failed). */
export const ENRICHMENT_VARIANT: Record<string, BadgeVariant> = {
  done: 'success',
  manual: 'info',
  pending: 'warning',
  not_found: 'neutral',
  none: 'neutral',
  failed: 'error',
}
